import { FLAGS, IsFlagActive } from '@rover/rsdk/src/modules/Data/Core/FrontendConfiguration';

const shouldLoadAmplitudeSessionReplay = (isFlagActive: IsFlagActive, currentUrl: URL): boolean => {
  if (
    isFlagActive(FLAGS.ROLLOUT_SSR_SEARCH_SESSION_REPLAY) &&
    currentUrl.pathname.startsWith('/search')
  ) {
    return true;
  }

  // Allow enable session replay via url query param for initial sitespeed performance testing
  if (currentUrl.searchParams.get('asrEnabled') === 'true') {
    return true;
  }

  return false;
};

export default shouldLoadAmplitudeSessionReplay;
